import { openDB, IDBPDatabase } from 'idb';

import { LocalStorage } from './LocalStorageAbstract';

export class LocalStorageIndexedDb extends LocalStorage {
  private dbPromise: Promise<IDBPDatabase>;

  private storeName: string;

  constructor(databaseName: string, storeName: string, databaseVersion: number) {
    super();

    this.storeName = storeName;

    this.dbPromise = openDB(databaseName, databaseVersion, {
      upgrade(db) {
        db.createObjectStore(storeName);
      },
    });
  }

  async put<T = unknown>(key: string, value: T) {
    const db = await this.dbPromise;
    await db.put(this.storeName, value, key);
    return value;
  }

  async get<T = unknown>(key: string) {
    const db = await this.dbPromise;
    const value = await db.get(this.storeName, key);

    if (value === undefined) {
      return undefined;
    }

    return value as T;
  }

  async delete(key: string) {
    const db = await this.dbPromise;
    return db.delete(this.storeName, key);
  }

  async clear() {
    const db = await this.dbPromise;
    return db.clear(this.storeName);
  }
}
